import React, { useEffect, useState } from "react";
import HeroDetail from "../../Recipes/HeroDetail/heroDetail";
import TextSectionNews from "../TextSectionNews/TextSectionNews";
import RelatedProductsDetail from "../../Recipes/RelatedProductsDetail/relatedProductsDetail";
import { getNewsRelated } from "../../../services/Noticias/getNewsRelated";
import Loader from "../../Loader/Loader";

const DetailNews = ({ news, country }) => {
  const [newsRelated, setNewsRelated] = useState();

  useEffect(() => {
    getNewsRelated(country, news.name)
      .then((products) => {
        setNewsRelated(products);
      })
      .catch((error) => {});
  }, [news.name, country]);

  return (
    <>
      <HeroDetail
        title={news.name}
        backgroundImage={news.image}
        news={news.type}
      />
      <TextSectionNews newsText={news.description} news={news} />
      {newsRelated === undefined ? (
        <Loader />
      ) : (
        <RelatedProductsDetail name={"novedades"} recipeRelated={newsRelated} />
      )}
    </>
  );
};

export default DetailNews;
